import PropTypes from "prop-types";
import cn from "classnames";
import scrollbarSize from "dom-helpers/scrollbarSize";
import React from "react";

import dates from "react-big-calendar/lib/utils/dates";
// import Header from './Header'
import notify from "react-big-calendar/lib/utils/helpers";

const Header = ({ label }) => {
  return <span>{label}</span>;
};

class TimeGridHeader extends React.Component {
  handleHeaderClick = (date, view, e) => {
    e.preventDefault();
    notify(this.props.onDrillDown, [date, view]);
  };

  renderHeaderCells(range) {
    let { localizer, getDrilldownView, getNow } = this.props;

    const today = getNow();

    return range.map((date, i) => {
      let label = localizer.format(date, "dayFormat");

      return (
        <div
          key={i}
          className={cn(
            "rbc-header",
            "rbc-total-cell",
            dates.eq(date, today, "day") && "rbc-today"
          )}
        >
          <span>{label}</span>
        </div>
      );
    });
  }

  render() {
    let {
      width,
      rtl,
      resources,
      range,
      events,
      getNow,
      accessors,
      selectable,
      components,
      getters,
      scrollRef,
      localizer,
      isOverflowing
    } = this.props;

    let style = {};
    if (isOverflowing) {
      style[rtl ? "marginLeft" : "marginRight"] = `${scrollbarSize()}px`;
    }

    const groupedEvents = [];

    return (
      <div
        style={style}
        ref={scrollRef}
        className={cn("rbc-time-header", isOverflowing && "rbc-overflowing")}
      >
        <div
          className="rbc-label rbc-time-header-gutter"
          style={{ width, minWidth: width, maxWidth: width }}
        />
        <div className="rbc-time-header-content">
          <div
            className={`rbc-row rbc-time-header-cell${
              range.length <= 1 ? " rbc-time-header-cell-single-day" : ""
            }`}
          >
            {this.renderHeaderCells(range)}
          </div>
        </div>
      </div>
    );
  }
}

export default TimeGridHeader;
